import { render, staticRenderFns } from "./SuggestionArgument.vue?vue&type=template&id=0a3e5419&scoped=true&"
import script from "./SuggestionArgument.vue?vue&type=script&lang=js&"
export * from "./SuggestionArgument.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionArgument.vue?vue&type=style&index=0&id=0a3e5419&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3e5419",
  null
  
)

export default component.exports